var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrownLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brown-lock_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#802D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66.279%",
    stopColor: "#D37E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.131%",
    stopColor: "#FBB076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "89.005%",
    stopColor: "#D68044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#792C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brown-lock_svg__b",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#802D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66.279%",
    stopColor: "#D37E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.131%",
    stopColor: "#FBB076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "89.005%",
    stopColor: "#D68044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#792C00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1E7EE",
    d: "M-1126-744H314v985h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-695-79h883a6 6 0 016 6V31h-895V-73a6 6 0 016-6z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-12 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.5,
    height: 30.5,
    x: 0.75,
    y: 0.75,
    fill: "#FFF",
    stroke: "url(#brown-lock_svg__a)",
    strokeWidth: 1.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7.25v-.001h1.833v.005l.034.003A1 1 0 0111 8.25V15a1 1 0 01-1 1H1a1 1 0 01-1-1V8.25a1 1 0 01.916-.997L.915 7.25H8.25zm-.806 1.867H3.89l-.223.876h1.027c.372.004.627.121.766.352l.046.091H3.863l-.196.714h1.862c-.105.319-.348.496-.728.53l-.148.008h-.896l.004.634 1.828 2.045h1.25v-.05l-1.65-1.869c.453-.084.8-.232 1.043-.443a1.35 1.35 0 00.419-.706l.03-.149h.563l.2-.714h-.76a1.546 1.546 0 00-.146-.467l-.08-.135h.79l.196-.717zM5.5 2a4.583 4.583 0 014.583 4.583v.229H8.25V6.5a2.75 2.75 0 00-4.76-1.877L2.33 3.274A4.558 4.558 0 015.5 2z",
    fill: "url(#brown-lock_svg__b)",
    transform: "translate(12 7)"
  })))));
}
export default SvgBrownLock;